"use strict";
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWidgetModal = void 0;
// Files in this directory should contain only types and type guards-like functions
__exportStar(require("./Data"), exports);
__exportStar(require("./WidgetConfig"), exports);
__exportStar(require("./SectionConfig"), exports);
__exportStar(require("./NavigationTypes"), exports);
const isWidgetModal = (widgetConfig) => widgetConfig.isModal === true;
exports.isWidgetModal = isWidgetModal;
//# sourceMappingURL=index.js.map